import type { SpartacuxCoreState } from '@/domains/core/core.state';

export const selectABTasty = (state: SpartacuxCoreState) => state.core?.ABTasty;
